var disposed = false
/* script */
export * from "!!babel-loader!./altitude.js"
import __vue_script__ from "!!babel-loader!./altitude.js"/* template */
import {render as __vue_render__, staticRenderFns as __vue_static_render_fns__} from "!!../../../../node_modules/.pnpm/vue-loader@14.2.4_babel-core@7.0.0-bridge.0_@babel+core@7.29.0__css-loader@3.6.0_webpack@5.10_4tg72wvcfmnxgngn6zjted3j5a/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-086c01da\",\"hasScoped\":false,\"optionsId\":\"0\",\"buble\":{\"transforms\":{}}}!../../../../node_modules/.pnpm/vue-loader@14.2.4_babel-core@7.0.0-bridge.0_@babel+core@7.29.0__css-loader@3.6.0_webpack@5.10_4tg72wvcfmnxgngn6zjted3j5a/node_modules/vue-loader/lib/selector?type=template&index=0!./Altitude.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
import normalizeComponent from "!../../../../node_modules/.pnpm/vue-loader@14.2.4_babel-core@7.0.0-bridge.0_@babel+core@7.29.0__css-loader@3.6.0_webpack@5.10_4tg72wvcfmnxgngn6zjted3j5a/node_modules/vue-loader/lib/runtime/component-normalizer"
var Component = normalizeComponent(
  __vue_script__,
  __vue_render__,
  __vue_static_render_fns__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)
Component.options.__file = "src/fragments/charts/altitude/Altitude.vue"

/* hot reload */
if (module.hot) {(function () {
  var hotAPI = require("vue-hot-reload-api")
  hotAPI.install(require("vue"), false)
  if (!hotAPI.compatible) return
  module.hot.accept()
  if (!module.hot.data) {
    hotAPI.createRecord("data-v-086c01da", Component.options)
  } else {
    hotAPI.reload("data-v-086c01da", Component.options)
  }
  module.hot.dispose(function (data) {
    disposed = true
  })
})()}

export default Component.exports
